<template>
  <div class="autocomplete">
    <div class="control has-icons-right">
      <div
        v-if="!disabledLookup"
        class="autofill-button"
        :class="{ 'is-loading': isLoading }"
        @click="autofill"
      >
        <span v-if="!isLoading">Find Address</span>
        <span v-else class="spinner"></span>
      </div>
      <input
        id="pcodehouse"
        v-model="search"
        :name="name"
        type="text"
        required
        autocomplete="new-password"
        class="input"
        @input="onChange"
      />
      <label class="form-control-placeholder" for="pcodehouse">
        Postcode
      </label>
      <span
        v-if="isAddressReady && !disabledLookup"
        class="icon is-danger is-small is-right postcode-right-icon"
      >
        <div class="checkbox-icon"></div>
      </span>
      <span :class="{ 'is-danger': errors }" class="help">{{ errors }}</span>
      <ul
        v-show="isOpen"
        id="autocomplete-results"
        class="autocomplete-results"
      >
        <li v-if="isLoading" class="autocomplete-result">Loading...</li>
        <li
          v-for="(result, i) in results"
          v-else
          :key="i"
          :class="{ 'is-active': i === arrowCounter }"
          class="autocomplete-result"
          @click="onSelect(result)"
        >
          {{ result.id || result.text || result.notFoundText }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  $_veeValidate: {
    value() {
      return this.$el.value
    },
    name() {
      return this.name
    },
  },
  // props: ['handleChange', 'name', 'postcode', 'errors'],
  props: {
    handleChange: {
      type: Function,
      default: () => {},
    },
    name: {
      type: String,
      default: 'name',
    },
    postcode: {
      type: String,
      default: 'postcode',
    },
    errors: {
      type: String,
      default: '',
    },
    disabledLookup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      results: [],
      search: '',
      isLoading: false,
      arrowCounter: 0,
      isAddressReady: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    setTimeout(() => {
      this.search = this.postcode
    }, 10)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    onChange(event) {
      // Uppercase first, so the parent and the search get the current value
      // rather than the one from before this keystroke.
      this.search = event.target.value.toUpperCase()
      this.isAddressReady = false
      // notify the parent that a change was made
      this.$emit('input', this.search)
      if (this.search.length >= 1) {
        this.searchPostcode()
      }
    },
    createAddressObject(addressString, postcode) {
      const tmpObj = addressString.split(',')

      const lookupAddress = {
        address: '',
        street: '',
        city: tmpObj[5],
        county: tmpObj[6],
        postcode,
      }
      if (tmpObj[2] !== ' ') {
        lookupAddress.address = tmpObj[0] + tmpObj[1]
        lookupAddress.street = tmpObj[2]
      }
      if (tmpObj[2] === ' ' && tmpObj[1] === ' ') {
        const hs = tmpObj[0].split(' ')
        lookupAddress.address = hs[0]
        hs.splice(0, 1) // remove first element used as address
        lookupAddress.street = hs.join(' ')
      }
      if (tmpObj[2] === ' ' && tmpObj[1] !== ' ') {
        lookupAddress.address = tmpObj[0]
        lookupAddress.street = tmpObj[1]
      }
      if (tmpObj[6] === ' ') {
        lookupAddress.county = tmpObj[5]
      }
      return lookupAddress
    },
    onSelect(result) {
      if (result.id) {
        this.search = result.id
        if (!this.disabledLookup) {
          this.postcodeLookUp(this.search)
        } else {
          this.isOpen = false
          const addressObject = {
            address: '',
            street: '',
            city: '',
            county: '',
            postcode: this.search,
          }
          this.$emit('handleChange', addressObject)
          this.isAddressReady = true
        }
      } else if (result.fullAddress) {
        this.isOpen = false
        const address = result.fullAddress
        const postCode = this.search
        const addressObject = { ...address, postcode: postCode }
        this.$emit('handleChange', addressObject)
        this.isAddressReady = true
      }
    },
    // onEnter() {
    //   if (this.results[this.arrowCounter].id) {
    //     setTimeout(() => {
    //       this.search = this.results[this.arrowCounter].id
    //       this.postcodeLookUp(this.search)
    //     }, 10)
    //   } else {
    //     this.isOpen = false
    //     const address = this.results[this.arrowCounter].fullAddress
    //     const postCode = this.search
    //     const addressObject = { ...address, postcode: postCode }
    //     this.$emit('handleChange', addressObject)
    //   }
    // },
    // onArrowDown() {
    //   if (this.arrowCounter < this.results.length - 1) {
    //     this.arrowCounter = this.arrowCounter + 1
    //   }
    // },
    // onArrowUp() {
    //   if (this.arrowCounter > 0) {
    //     this.arrowCounter = this.arrowCounter - 1
    //   }
    // },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false
        this.arrowCounter = -1
      }
    },
    async autofill() {
      if (!this.search) return
      try {
        const { result } = await this.$axios.$get(
          `/api/helpers/v1/validate-postcode/${this.search}`
        )
        if (result) {
          this.postcodeLookUp(this.search)
        } else {
          // If not a full postcode, maybe try to search
          this.searchPostcode()
        }
      } catch (e) {
        // Fallback to direct lookup if validation fails for some reason
        this.postcodeLookUp(this.search)
        console.log('Error validating postcode', e)
      }
    },
    async searchPostcode() {
      this.isLoading = true
      this.isOpen = true
      try {
        const apiResult = await this.$axios.$get(
          `/api/helpers/v1/search-postcode/${this.search}`
        )

        this.results = apiResult.filter(
          (item) => !item.text.startsWith('GY') && !item.text.startsWith('JE')
        )
        this.isLoading = false
      } catch {
        this.results = [{ notFoundText: 'Postcode not found' }]
        this.isLoading = false
      }
    },
    postcodeLookUp(postcode) {
      this.results = []
      this.isLoading = true
      this.isOpen = true
      axios
        .get(
          `https://api.ideal-postcodes.co.uk/v1/postcodes/${postcode}?api_key=ak_mn5tzbn2VGJjiLMg0VhCQiPeGxkyU`
        )
        .then((response) => {
          this.results = response.data.result
            .filter(
              (address) =>
                !address.post_town.startsWith('Guernsey') &&
                !address.post_town.startsWith('Jersey')
            )
            .map((address) => {
              const addressObj = {
                address: address.line_1,
                street: address.line_2 || address.line_1,
                city: address.post_town,
                county: address.county || '-',
              }
              const _text = [
                address.line_1,
                address.line_2,
                address.line_3,
                address.post_town,
              ]
                .filter((item) => item)
                .join(', ')
              return { final: true, text: _text, fullAddress: addressObj }
            })
          this.isLoading = false
          this.isOpen = true
          this.arrowCounter = 0
        })
        .catch((e) => {
          console.log('Address lookup failed, using postcode only', e)
          this.isLoading = false
          this.isOpen = false
          const addressObject = {
            address: '',
            street: '',
            city: '',
            county: '',
            postcode,
          }
          this.$emit('handleChange', addressObject)
          this.isAddressReady = true
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.autofill-button {
  position: absolute;
  display: block;
  z-index: 1;
  right: 1px;
  width: 100px;
  line-height: 40px;
  background: $ps-primary;
  height: 43px;
  top: 1px;
  border-radius: 0 15px 15px 0;
  color: white;
  font-size: 12px;
  text-align: center;
  cursor: pointer;

  .spinner {
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
.autocomplete-input {
  margin: 0;
}
.autocomplete {
  position: relative;
  width: 100%;
}
.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #e2e2e2 !important;
  border-radius: 0 0 5px 5px;
  max-height: 160px;
  min-height: 40px;
  height: auto;
  overflow: auto;
  width: 100%;
  position: absolute;
  z-index: 20;
  background: white;
}
.autocomplete-result {
  border-bottom: 1px solid white;
  list-style: none;
  text-align: left;
  padding: 5px 10px;
  cursor: pointer;
  color: #000 !important;
}
.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: $ps-primary;
  color: white !important;
}
.loading {
  margin: -8px;
  .spinner {
    width: 40px;
    height: 40px;
    top: -5px;
  }
}
.postcode-right-icon {
  padding-right: 130px;
  display: block;
  top: 12px !important;
}
.checkbox-icon {
  display: block;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid $ps-primary;
  margin-right: 10px;
  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 0px;
  }
  &:before {
    top: 6px;
    height: 50%;
    width: 3px;
    background-color: $ps-primary;
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
  }
  &:after {
    bottom: 3px;
    height: 3px;
    width: 100%;
    background-color: $ps-primary;
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
  }
}
</style>
